import React from "react";
import { IconComponent, icon } from "../../../../../../../../common/components";
import styles from "./LockedBanner.module.css";
import { translate } from "../../../../../../../../common/providers";

const LockedBanner = ({ noteStatus }) => (
	<div className={styles.container}>
		<div>
			<IconComponent color="var(--color-orange)" icon={icon.faLock} />
		</div>
		<div>
			<div className={styles.title}>
				{translate("notes.right-panel.header.note-locked.title", { userName: noteStatus.lockedBy })}
			</div>
			<div>{translate("notes.right-panel.header.note-locked.helper")}</div>
		</div>
	</div>
);

export default LockedBanner;
